import React from "react";
import "../CampaignComponent/CampaginComponentCss/DownloadCard.css";

export default function DownloadCard() {
  return (
    <div className="download-card-wrapper">
      <div className="download-card-box">
        
        <p className="download-card-title">
          ग्रामविकास व पंचायत राज विभाग
        </p>

        <button className="download-card-btn">
          <svg 
            width="18" 
            height="18" 
            viewBox="0 0 24 24" 
            fill="none" 
            xmlns="http://www.w3.org/2000/svg"
            className="download-svg-icon"
          >
            <path 
              d="M12 3V15" 
              stroke="white" 
              strokeWidth="2" 
              strokeLinecap="round"
            />
            <path 
              d="M6 9L12 15L18 9" 
              stroke="white" 
              strokeWidth="2" 
              strokeLinecap="round"
            />
            <path 
              d="M5 17H19" 
              stroke="white" 
              strokeWidth="2" 
              strokeLinecap="round"
            />
          </svg>

          PDF डाउनलोड करा
        </button>

      </div>
    </div>
  );
}
